<template>
  <div v-if="isLocked">
    <span class="label label-danger"> {{ $i18n.t('Locked by') }}: {{ lockUser }} - {{ lockTime | date }} </span>
  </div>
</template>

<script>
import { formatDateTime } from '@/filters/date'

/**
 * @class FormLock
 *
 * @description This component renders an alert on the Form if it is locked
 */
export default {
  name: 'form-lock',
  props: {
    isLocked: {
      default: false,
    },
    lockUser: {
      type: String,
    },
    lockTime: {
      type: String,
    },
  },
  filters: {
    date: function (value) {
      return formatDateTime(value)
    },
  },
}
</script>
